/* esm.sh - unist-util-visit-parents@6.0.2/do-not-use-color */
export * from "/*unist-util-visit-parents@6.0.2/esnext/do-not-use-color.mjs";
